/** Display size for marketing matchup card headshots (px). */
export const MARKETING_HEADSHOT_DISPLAY_SIZE = 52;

/** CDN transform width — ~2× display for retina; far smaller than scraper's w_213. */
const CDN_WIDTH = 80;

const MLB_CDN_BASE =
  "https://img.mlbstatic.com/mlb-photos/image/upload/d_people:generic:headshot:67:current.png";

const NBA_CDN_BASE = "https://cdn.nba.com/headshots/nba/latest/260x190";

const NFL_ESPN_CDN_BASE =
  "https://a.espncdn.com/i/headshots/nfl/players/full";

/**
 * Preset playerId → public CDN headshot for unauthenticated marketing cards.
 * Same pattern as the in-app photo fallbacks (MLB Stats API, NBA.com, ESPN).
 * Do not route these through /api/.../headshots — those need auth.
 */
export const MARKETING_HEADSHOT_SOURCES = {
  ruthba01: { sport: "mlb", id: "121578" },
  bondsba01: { sport: "mlb", id: "111188" },
  mantlmi01: { sport: "mlb", id: "118258" },
  mayswi01: { sport: "mlb", id: "118495" },
  martipe02: { sport: "mlb", id: "118377" },
  kershcl01: { sport: "mlb", id: "477132" },
  griffke02: { sport: "mlb", id: "115135" },
  troutmi01: { sport: "mlb", id: "545361" },
  henderi01: { sport: "mlb", id: "115910" },
  rodrial01: { sport: "mlb", id: "121347" },
  // MLB CDN has no current headshot for these retired players (generic silhouette).
  kentje01: { sport: "mlb", wikimedia: "Jeff Kent, baseball player.jpg" },
  schmimi01: { sport: "mlb", wikimedia: "Mike Schmidt - Philadelphia Phillies - 1983.jpg" },
  ohtansh01: { sport: "mlb", id: "660271" },
  pujolal01: { sport: "mlb", id: "405395" },
  berrayo01: { sport: "mlb", wikimedia: "Yogi Berra - New York Yankees - 1957.jpg" },
  jamesle01: { sport: "nba", id: "2544" },
  jordami01: { sport: "nba", id: "893" },
  curryst01: { sport: "nba", id: "201939" },
  duncati01: { sport: "nba", id: "1495" },
  onealsh01: { sport: "nba", id: "406" },
  brad06400: { sport: "nfl", id: "2330" },
  peyt01800: { sport: "nfl", id: "1428" },
};

export const buildMlbMarketingHeadshotUrl = (mlbId, width = CDN_WIDTH) =>
  `${MLB_CDN_BASE}/w_${width},q_auto:best/v1/people/${mlbId}/headshot/67/current`;

export const buildNbaMarketingHeadshotUrl = (nbaId) =>
  `${NBA_CDN_BASE}/${nbaId}.png`;

export const buildNflMarketingHeadshotUrl = (espnId) =>
  `${NFL_ESPN_CDN_BASE}/${espnId}.png`;

export const buildWikimediaMarketingHeadshotUrl = (fileName, width = 160) =>
  `https://commons.wikimedia.org/wiki/Special:FilePath/${encodeURIComponent(
    fileName
  )}?width=${width}`;

const URL_BUILDERS = {
  mlb: (id) => buildMlbMarketingHeadshotUrl(id),
  nba: (id) => buildNbaMarketingHeadshotUrl(id),
  nfl: (id) => buildNflMarketingHeadshotUrl(id),
};

export const getMarketingHeadshotUrl = (playerId) => {
  const source = MARKETING_HEADSHOT_SOURCES[playerId];
  if (!source) return null;
  if (source.wikimedia) return buildWikimediaMarketingHeadshotUrl(source.wikimedia);
  const build = URL_BUILDERS[source.sport];
  return build ? build(source.id) : null;
};

export const getAllMarketingHeadshotUrls = () =>
  Object.keys(MARKETING_HEADSHOT_SOURCES)
    .map(getMarketingHeadshotUrl)
    .filter(Boolean);

/** Warm browser cache for all preset marketing headshots (parallel, no API). */
export const preloadMarketingHeadshots = () => {
  getAllMarketingHeadshotUrls().forEach((url) => {
    const img = new Image();
    img.src = url;
  });
};
